import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { environment } from '@pg-env/environment';

@Directive({
    // tslint:disable-next-line:directive-selector
    selector: '[imageWithEnvironmentPrefix]'
})
export class ImageWithEnvironmentPrefixDirective implements OnInit {
    @Input() imageWithEnvironmentPrefix: string;
    protected imageElement: any;
    
    constructor(
        private viewContainerRef: ViewContainerRef,
        private templateRef: TemplateRef<any>
    ) { }
    public envenvironment = environment;
    ngOnInit() {
        this.loadImageWithBrand();
    }

    private loadImageWithBrand() {     
        this.viewContainerRef.createEmbeddedView(this.templateRef);
        const srcWithBrandPrefix = this.getNameWithBrandPrefix();
        this.templateRef.elementRef.nativeElement.previousSibling.src = srcWithBrandPrefix;
        
    }

    private getNameWithBrandPrefix() {
        let oldPath = this.imageWithEnvironmentPrefix;
        var splitFilename = oldPath.split("/");
        let oldFileName = splitFilename.slice(-1)[0];
        var newPath = splitFilename.slice(0, splitFilename.length - 1).join("/")
        if (newPath.length !== 0) {
            newPath += "/"
        }
        newPath = newPath + this.envenvironment.environmentPrefix + oldFileName;
        return newPath;
    }
}
